import React from 'react';
import {withStyles, withStylesCompose} from '@/hocs/withStyles';
import {withFlexHolder} from '@/hocs/withFlex';
import styles from './section.module.scss';

const PlainSection = props => <section {...props} />;
const Section = withStyles(PlainSection, styles, 'section');

const SectionPaddingHero = withFlexHolder(withStyles(Section, styles, 'section-padding-hero'));
const SectionPaddingHeroToZero = withFlexHolder(
  withStyles(Section, styles, 'section-padding-hero-to-zero')
);
const SectionPaddingHeroRegular = withFlexHolder(
  withStyles(Section, styles, 'section-padding-hero-regular')
);
const SectionPaddingTop = withStyles(Section, styles, 'section-padding-top');
const SectionSpacedTopLgToDouble = withStyles(Section, styles, 'section-spaced-top-lg-to-double');
const SectionSpacedTopLgToHeroPlus = withStyles(
  Section,
  styles,
  'section-spaced-top-lg-to-hero-plus'
);
const SectionPaddingBottom = withStyles(Section, styles, 'section-padding-bottom');
const SectionPaddingHalfBottom = withStyles(Section, styles, 'section-padding-half-bottom');
const SectionPaddingHeroReverse = withStyles(Section, styles, 'section-padding-hero-reverse');
const SectionPaddingHomeHero = withStyles(Section, styles, 'section-padding-homepage-hero');
const SectionPadding = withStyles(Section, styles, 'section-padding');
const SectionPaddingMdToZero = withStyles(Section, styles, 'section-spaced-md-t-0');
const SectionPaddingHalf = withStyles(Section, styles, 'section-padding-half');
const SectionPaddingHalfTop = withStyles(Section, styles, 'section-padding-half-top');
const SectionDemoBg = withStylesCompose(Section, styles, ['demo-bg']);
const SectionFreeTrialBg = withStylesCompose(Section, styles, ['free-trial-bg']);
const SectionPartnershipApplicationBg = withStylesCompose(Section, styles, [
  'partnership-application-bg'
]);
const SectionRoiCalculatorBg = withStylesCompose(Section, styles, ['roi-calculator-bg']);
const SectionPaddingTopAd = withStyles(Section, styles, 'section-padding-top-ad');
const SectionNegativeMarginTop = withStyles(Section, styles, 'section-negative-margin');
const SectionWithElevatedIndex = withStyles(Section, styles, 'section-with-elevated-index');

export {
  Section,
  SectionPaddingHero,
  SectionPaddingHeroToZero,
  SectionPaddingHeroReverse,
  SectionPaddingHeroRegular,
  SectionSpacedTopLgToDouble,
  SectionSpacedTopLgToHeroPlus,
  SectionPaddingHomeHero,
  SectionPaddingTop,
  SectionPadding,
  SectionPaddingMdToZero,
  SectionPaddingHalf,
  SectionPaddingHalfTop,
  SectionPaddingBottom,
  SectionPaddingHalfBottom,
  SectionDemoBg,
  SectionFreeTrialBg,
  SectionPartnershipApplicationBg,
  SectionRoiCalculatorBg,
  SectionPaddingTopAd,
  SectionNegativeMarginTop,
  SectionWithElevatedIndex
};
